import { EntityDrawerProvider } from './context/EntityDrawerContext';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { FeedbackProvider } from './context/FeedbackContext';
import AppShell from './components/AppShell';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import DashboardDetailPage from './pages/DashboardDetailPage';
import ImportHexawarePOsPage from './pages/ImportHexawarePOsPage';
import HelpPage from './pages/HelpPage';
import ContractorsPage from './pages/ContractorsPage';
import ContractorProfilePage from './pages/ContractorProfilePage';
import VendorsPage from './pages/VendorsPage';
import VendorProfilePage from './pages/VendorProfilePage';
import ClientsPage from './pages/ClientsPage';
import ClientProfilePage from './pages/ClientProfilePage';
import WorkOrdersPage from './pages/WorkOrdersPage';
import WorkOrderProfilePage from './pages/WorkOrderProfilePage';
import PurchaseOrdersPage from './pages/PurchaseOrdersPage';
import PurchaseOrderProfilePage from './pages/PurchaseOrderProfilePage';
import TimesheetsPage from './pages/TimesheetsPage';
import SearchResultsPage from './pages/SearchResultsPage';
import ARInvoicesPage from './pages/ARInvoicesPage';
import ARInvoiceProfilePage from './pages/ARInvoiceProfilePage';
import APInvoicesPage from './pages/APInvoicesPage';
import APPaymentsPage from './pages/APPaymentsPage';
import VendorRemittancesPage from './pages/VendorRemittancesPage';
import APInvoiceProfilePage from './pages/APInvoiceProfilePage';
import PeoplePage from './pages/PeoplePage';
import BankReconciliationPage from './pages/BankReconciliationPage';
import AuditLogPage from './pages/AuditLogPage';
import SettingsPage from './pages/SettingsPage';
import ExpensesPage from './pages/ExpensesPage';
import LedgersPage from './pages/LedgersPage';
import AgingReportPage from './pages/AgingReportPage';
import PlaceholderPage from './pages/PlaceholderPage';
import './index.css';

function PrivateRoute({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return <AppShell>{children}</AppShell>;
}

export default function App() {
  return (
    <ThemeProvider>
      <FeedbackProvider>
      <AuthProvider>
        <BrowserRouter><EntityDrawerProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<PrivateRoute><DashboardPage /></PrivateRoute>} />
            <Route path="/dashboard-detail" element={<PrivateRoute><DashboardDetailPage /></PrivateRoute>} />
            <Route path="/import-hexaware-pos" element={<PrivateRoute><ImportHexawarePOsPage /></PrivateRoute>} />
            <Route path="/help" element={<PrivateRoute><HelpPage /></PrivateRoute>} />
            <Route path="/contractors" element={<PrivateRoute><ContractorsPage /></PrivateRoute>} />
            <Route path="/contractors/:id" element={<PrivateRoute><ContractorProfilePage /></PrivateRoute>} />
            <Route path="/vendors" element={<PrivateRoute><VendorsPage /></PrivateRoute>} />
            <Route path="/vendors/:id" element={<PrivateRoute><VendorProfilePage /></PrivateRoute>} />
            <Route path="/clients" element={<PrivateRoute><ClientsPage /></PrivateRoute>} />
            <Route path="/clients/:id" element={<PrivateRoute><ClientProfilePage /></PrivateRoute>} />
            <Route path="/work-orders" element={<PrivateRoute><WorkOrdersPage /></PrivateRoute>} />
            <Route path="/work-orders/:id" element={<PrivateRoute><WorkOrderProfilePage /></PrivateRoute>} />
            <Route path="/purchase-orders" element={<PrivateRoute><PurchaseOrdersPage /></PrivateRoute>} />
            <Route path="/purchase-orders/:id" element={<PrivateRoute><PurchaseOrderProfilePage /></PrivateRoute>} />
            <Route path="/timesheets" element={<PrivateRoute><TimesheetsPage /></PrivateRoute>} />
            <Route path="/search" element={<PrivateRoute><SearchResultsPage /></PrivateRoute>} />
            <Route path="/ap-invoices" element={<PrivateRoute><APInvoicesPage /></PrivateRoute>} />
            <Route path="/ap-invoices/:id" element={<PrivateRoute><APInvoiceProfilePage /></PrivateRoute>} />
            <Route path="/ap-payments" element={<PrivateRoute><APPaymentsPage /></PrivateRoute>} />
            <Route path="/vendor-remittances" element={<PrivateRoute><VendorRemittancesPage /></PrivateRoute>} />
            <Route path="/ar-invoices" element={<PrivateRoute><ARInvoicesPage /></PrivateRoute>} />
            <Route path="/ar-invoices/:id" element={<PrivateRoute><ARInvoiceProfilePage /></PrivateRoute>} />
            <Route path="/expenses" element={<PrivateRoute><ExpensesPage /></PrivateRoute>} />
            <Route path="/people" element={<PrivateRoute><PeoplePage /></PrivateRoute>} />
            <Route path="/ledgers" element={<PrivateRoute><LedgersPage /></PrivateRoute>} />
            <Route path="/aging-report" element={<PrivateRoute><AgingReportPage /></PrivateRoute>} />
            <Route path="/reconciliation" element={<PrivateRoute><BankReconciliationPage /></PrivateRoute>} />
            <Route path="/settings" element={<PrivateRoute><SettingsPage /></PrivateRoute>} />
            <Route path="/audit-log" element={<PrivateRoute><AuditLogPage /></PrivateRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </EntityDrawerProvider></BrowserRouter>
      </AuthProvider>
      </FeedbackProvider>
    </ThemeProvider>
  );
}
